import ExcelJS from "exceljs";
import { Entidad } from "../../../../data/Entidad";
import { UIUtilPermission } from "../../../util/Permission";
import { NotificacionV2 } from "../../NotificacionV2";
// import { _SvAdmin_GetExcelTemplateToExport, IExportarExcelPlantillaInfo } from "../../data/modulo/Admin";
// import { IExcelExportColumnConfig, IExcelExportConfig, IExcelExportSheetConfig_ } from "../../ExcelThings/Export/Export";
import { Main } from "../../../../Main";
import { _SvAdmin_GetExcelTemplateToExport, IExportarExcelPlantillaInfo } from "../../../../data/modulo/Admin";
import _L from "../../../../util/Labels";
import { HTMLProgressElement } from "../../../controlWC/ProgressComponent";
import { ExcelThingsExportWriteWorksheet as utilWSheet } from "../../ExcelThings/Export/WriteWorksheet";
import { ExcelThingsUtil as util } from "../../ExcelThings/Util";


export interface IExcelExportColumnConfig<TData> {
    Field: keyof TData;
    HeaderTag: string;
    /** @default 20 */
    WidthCell?: number;
    /** @default "text" */
    TypeData?: "text" | "date" | "number" | "email";
}

export interface IExcelExportSheetConfig<TData> {
    /** Recomendado para Id de Escuela */
    IdSheet: number;
    /** Los nombres por hoja deben ser únicos */
    SheetName: string;
    Data: TData[];
    ExtraPie?: {
        Label: string;
        Value: string | number;
        /** @default "left" */
        Alignment?: Partial<ExcelJS.Alignment>["horizontal"];
    }[];
}

export interface IExcelExportConfig<TData> {
    ColumnsConfig: IExcelExportColumnConfig<TData>[];
    /** @default true */
    ConsultarLogos?: boolean;
    FileName: string;
    IdCategoria: number;
    IdsEscuelas: number[];
    Modulo: Entidad.CModulo;
    OnGetDataBySheets: () => Promise<IExcelExportSheetConfig<TData>[]>;
    OnGetEscuelasTagInSheet: (datos: TData[]) => string;
    OnStepFieldInDataRow?: (field: keyof TData, dato: TData) => (string | number) | Promise<(string | number)>; // Date // NOTE SE PUEDE??
    RequestType: Entidad.CTipoRequest;
    /** @default por defecto es el mismo que FileName */
    TagEncabezadoHoja?: string;
    ElementToAppendProgressBar?: d3.Selection<HTMLElement, any, any, any>;
}




type IInfoImagenExcel = util.IInfoImagenExcel
type IConfigLogo = util.IConfigLogo

export type IColumnToExcelExportFileConfig<TData> = IExcelExportColumnConfig<TData>
export type ISheetConfig<TData> = IExcelExportSheetConfig<TData>
export type IConfigExcelExport<TData> = IExcelExportConfig<TData>

export interface IExportExcelReturns {
    Promise: Promise<void>;
    ProgressBar: HTMLProgressElement;
}

export function _ExportExcelData<T>(config: IConfigExcelExport<T>): IExportExcelReturns {

    // >> Verifica permisos
    if (config.Modulo) {
        let permissionInfo = UIUtilPermission._HasActionsPermissionFromManySchools(Entidad.CAccionPermiso.ExportarAExcel, config.Modulo, config.IdsEscuelas);
        if (!permissionInfo.HasPermission) {
            // mostrar mensaje
            NotificacionV2._Mostrar(permissionInfo.Message, "ADVERTENCIA");
            return { Promise: Promise.resolve(), ProgressBar: null };
        }
    }

    // >> Prepara config
    config.TagEncabezadoHoja = config.TagEncabezadoHoja || config.FileName;
    config.ElementToAppendProgressBar = (config.ElementToAppendProgressBar || Main._Template._ContenedorPrincipal) as d3.Selection<HTMLElement, any, any, any>;
    config.ConsultarLogos = config.ConsultarLogos == null ? true : config.ConsultarLogos;
    config.ColumnsConfig.forEach(d => {
        d.TypeData = d.TypeData || "text";
        d.WidthCell = d.WidthCell || 20;
    })

    // >> Init
    const progressBar: HTMLProgressElement = new HTMLProgressElement();
    progressBar._Visible = true;
    config.ElementToAppendProgressBar.append(() => progressBar);

    Main._Template._ContenedorPrincipal
        .classed("cursor-progress", true);

    let RemoveProgress = (mess?) => {
        progressBar._Visible = false;

        Main._Template._ContenedorPrincipal
            .classed("cursor-progress", false);

        if (mess) {
            console.warn("-d", "Excel Export -> ", mess);
        }
    }

    let idsSchoolsToGetLogos = [];
    if (config.ConsultarLogos) {
        idsSchoolsToGetLogos = config.IdsEscuelas;
    }
    const promise = _SvAdmin_GetExcelTemplateToExport(idsSchoolsToGetLogos, config.IdCategoria, config.RequestType)
        .then(templateInfo => {
            if (templateInfo.Resultado <= 0) {
                NotificacionV2._Mostrar(_L("general.notif_fail"), "ADVERTENCIA");
                RemoveProgress("Error to get template data");
                return;
            }


            return util._LoadWorkbook(templateInfo.Datos.FileTemplate)
                .then(async (book) => {
                    let dataToExport = await config.OnGetDataBySheets();
                    if (dataToExport != null) {
                        dataToExport.forEach(d => {
                            // >> Recorta el nombre de Hoja, si tiene más de 30 carácteres, la lib truena
                            d.SheetName = d.SheetName.slice(0, 30);
                        })

                        // >> Start proccess
                        await ExportDataProccess(book, dataToExport, config, templateInfo.Datos.Info, templateInfo.Datos.EscuelaLogos);
                    }
                    RemoveProgress();
                })
                .catch(error => {
                    NotificacionV2._Mostrar(_L("general.notif_fail"), "ADVERTENCIA");
                    RemoveProgress(error);
                })
        });

    return { Promise: promise, ProgressBar: progressBar };
}

function ExportDataProccess<TDato>(book: ExcelJS.Workbook, dataToExport: ISheetConfig<TDato>[], config: IConfigExcelExport<TDato>, templateInfo: IExportarExcelPlantillaInfo, logosInfo?: Map<number, File>) {

    let columnaTablaExcel: ExcelJS.TableColumnProperties[] = [];

    let CopiaHojaOriginalPorKinder = function (sheetOrigin: ExcelJS.Worksheet) {
        dataToExport.forEach((d, k) => {
            let newWorkSheet: ExcelJS.Worksheet;
            let rowsOrigin = sheetOrigin.getRows(0, 20);
            newWorkSheet = book.addWorksheet(d.SheetName, {
                views: [
                    { showGridLines: false }
                ]
            });
            if (!newWorkSheet) return

            for (let a = 0; a < config.ColumnsConfig.length + 10; a++) {
                let lengthI = (d.Data.length < 20 ? 20 : d.Data.length) + 10;
                for (let i = 0; i <= lengthI; i++) {
                    let letra = util.ABCCOLS[a];
                    if (letra) {
                        newWorkSheet.getCell(letra + i).fill = {
                            type: 'pattern',
                            pattern: "lightHorizontal",
                            fgColor: { argb: 'FFFFFF' }
                        };
                    }
                    newWorkSheet.getRow(i).fill = {
                        type: 'pattern',
                        pattern: "lightHorizontal",
                        fgColor: { argb: 'FFFFFF' }
                    };
                }
            }
            newWorkSheet.properties = sheetOrigin.properties;

            for (let i = 1; i <= rowsOrigin.length; i++) {
                if (rowsOrigin[i]) {
                    rowsOrigin[i].eachCell((cellOrigin, noCol) => {
                        let newRow = newWorkSheet.getRow(i);
                        newWorkSheet.getColumn(noCol).width = sheetOrigin.getColumn(noCol).width;
                        newRow.height = rowsOrigin[i].height;

                        let newCell = newRow.getCell(cellOrigin.col);
                        newCell.value = cellOrigin.value;
                        newCell.style = cellOrigin.style;

                        // copy original cells merge
                        if (cellOrigin.address != cellOrigin.master.address) {
                            let mergeRef = cellOrigin.master.address + ":" + cellOrigin.address;
                            try {
                                newWorkSheet.mergeCells(mergeRef);
                            } catch (e) {
                                newWorkSheet.unMergeCells(mergeRef);
                                newWorkSheet.mergeCells(mergeRef);
                            }
                        }
                    });
                }
            }
        });
    }




    let InitExportar = async function (): Promise<boolean> {
        // >> Extrae las configuraciones de la plantilla
        let infoLogoBase: IInfoImagenExcel = book.worksheets[0].getImages()[0];
        let hojaOriginal = book.worksheets[0];
        hojaOriginal.name = "template";

        // AjustarDatos();
        config.ColumnsConfig.forEach((colConfig) => {
            columnaTablaExcel.push({ name: colConfig.HeaderTag, filterButton: false });
        })

        CopiaHojaOriginalPorKinder(hojaOriginal);

        // ListasPorEscuela.forEach((lista, idEscuela) => {
        for (let item of dataToExport) {
            let logoInfo: IConfigLogo;
            if (logosInfo?.has(item.IdSheet)) {
                logoInfo = await util._ReadLogo(book, logosInfo.get(item.IdSheet), item.SheetName, infoLogoBase);
            }

            await utilWSheet.InsertarDatosPorHoja(book, item, infoLogoBase, hojaOriginal, templateInfo, config, columnaTablaExcel, logoInfo);
        }

        // >> Remueve hoja base
        book.removeWorksheet("template");
        return await util._DownloadWorkbook(book, config.FileName);
    }

    return InitExportar();
}